import { useContext, useEffect, useState } from 'react'
import { ReportingContext } from '../../../contexts/reporting-context'
import { DeskBookingByDays } from './desk-booking-by-days/desk-booking-by-days'
import { DeskBookingByTeams } from './desk-booking-by-teams/desk-booking-by-teams'
import { ChartContainer, Container } from './reporting-charts-styles'

const ReportingCharts = () => {
  const { reportTeam } = useContext(ReportingContext)
  const [showAllCharts, setShowAllCharts] = useState(true)

  useEffect(() => {
    if (reportTeam) {
      setShowAllCharts(reportTeam.id === 'all-teams')
    }
  }, [reportTeam, setShowAllCharts])

  return (
    <Container>
      <ChartContainer>
        <DeskBookingByDays />
      </ChartContainer>
      {showAllCharts && (
        <ChartContainer>
          <DeskBookingByTeams />
        </ChartContainer>
      )}
    </Container>
  )
}

export default ReportingCharts
